var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.errorMsgStatus
      ? _c(
          "div",
          {
            staticClass: "alert alert-danger text-left",
            attrs: { role: "alert" }
          },
          [_vm._v("\n    " + _vm._s(_vm.errorMsg) + "\n  ")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.successMsgStatus
      ? _c(
          "div",
          {
            staticClass: "alert alert-success text-left",
            attrs: { role: "alert" }
          },
          [
            _c("span", { staticStyle: { "text-transform": "capitalize" } }, [
              _vm._v(_vm._s(_vm.successMsg))
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row no-gutters mb-3" }, [
      _c("div", { staticClass: "col-md-6 display-1 my-auto" }, [
        _c("span", [
          _vm._v(
            _vm._s(_vm.userFirstName.field_value) +
              " " +
              _vm._s(_vm.userLastName.field_value)
          )
        ]),
        _vm._v(" - Details")
      ]),
      _vm._v(" "),
      _vm.checkPermission("UpdateUser")
        ? _c("div", { staticClass: "col-md-6 text-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                attrs: {
                  type: "button",
                  tabindex: "1",
                  id: "edit-user-cancel"
                },
                on: { click: _vm.redirectToList }
              },
              [_vm._v("Cancel")]
            ),
            _vm._v(" "),
            _vm.checkPermission("UpdateUser")
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-success",
                    attrs: { type: "button", tabindex: "1" },
                    on: { click: _vm.saveUser }
                  },
                  [_vm._v("Save Changes")]
                )
              : _vm._e()
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mt-2 mb-4" }, [
      _c(
        "div",
        [
          _c(
            "b-tabs",
            {
              model: {
                value: _vm.tabIndex,
                callback: function($$v) {
                  _vm.tabIndex = $$v
                },
                expression: "tabIndex"
              }
            },
            [
              _c(
                "b-tab",
                {
                  staticClass: "mt-3",
                  attrs: { title: "User Details", active: _vm.activeTab1 }
                },
                [
                  _c("form", [
                    _c("div", { staticClass: "row no-gutters" }, [
                      _c("div", { staticClass: "col-12 col-md-6 mb-3" }, [
                        _c(
                          "div",
                          { staticClass: "mr-md-4 pb-3 rounded shadow-sm" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-head py-2 px-3 rounded-top text-white"
                              },
                              [_vm._v("User Details")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "float-right pr-3 mt-2 smaller-font-content"
                              },
                              [
                                _c("span", { staticClass: "star" }, [
                                  _vm._v("*")
                                ]),
                                _vm._v("Required")
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "px-3 my-2" },
                              [
                                _c("input-select", {
                                  attrs: { fieldData: _vm.agencyOptions }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "alert alert-warning text-left smaller-font-content py-2 mt-4",
                                    attrs: { role: "alert" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "row no-gutters w-100" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-inline-block my-auto mr-2 align-middle"
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fas fa-exclamation-circle"
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "d-inline-block col" },
                                          [
                                            _vm._v("An agent's "),
                                            _c("strong", [
                                              _vm._v("First Name")
                                            ]),
                                            _vm._v(", "),
                                            _c("strong", [
                                              _vm._v("Middle Initial")
                                            ]),
                                            _vm._v(" and "),
                                            _c("strong", [_vm._v("Last Name")]),
                                            _vm._v(
                                              " are required to match the agent's "
                                            ),
                                            _c("strong", [
                                              _vm._v("Agent of Record")
                                            ]),
                                            _vm._v(" in Progressive's system.")
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input-text", {
                                  attrs: { fieldData: _vm.userFirstName }
                                }),
                                _vm._v(" "),
                                _c("input-text", {
                                  attrs: { fieldData: _vm.userMiddleInitial }
                                }),
                                _vm._v(" "),
                                _c("input-text", {
                                  attrs: { fieldData: _vm.userLastName }
                                }),
                                _vm._v(" "),
                                _c("input-radio", {
                                  attrs: { fieldData: _vm.userRole }
                                }),
                                _vm._v(" "),
                                _vm.checkPermission("MarkAsTestUser")
                                  ? _c(
                                      "div",
                                      [
                                        _c("label", [_vm._v("Test User")]),
                                        _vm._v(" "),
                                        _c("input-checkbox", {
                                          attrs: {
                                            fieldData: _vm.userIsTestUser
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("input-phone", {
                                  attrs: { fieldData: _vm.userPhone }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 col-md-6 mb-3" }, [
                        _c(
                          "div",
                          { staticClass: "ml-md-4 pb-3 rounded shadow-sm" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-head py-2 px-3 rounded-top text-white"
                              },
                              [_vm._v("Account Email / Username")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "px-3 py-2" },
                              [
                                _c("input-text", {
                                  attrs: { fieldData: _vm.userEmail }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: { title: "Appointed Carriers" },
                  on: {
                    click: function($event) {
                      return _vm.tabAppointedCarrier()
                    }
                  }
                },
                [
                  _vm.currentProductAppointedCarriers !== null
                    ? [
                        _c("input-product-filter-appointed", {
                          attrs: {
                            emitToMethod: "onProductSwitch",
                            defaultProduct: _vm.selectedProduct,
                            productAccessData: _vm.productAccessData
                          },
                          on: { onProductSwitch: _vm.onProductSwitch }
                        }),
                        _vm._v(" "),
                        _c("AppointedCarrier", {
                          attrs: {
                            appointedcarrierdata:
                              _vm.currentProductAppointedCarriers,
                            active: _vm.activeTab2
                          }
                        })
                      ]
                    : _vm.currentProductAppointedCarriers === null
                    ? [
                        _c("div", { attrs: { id: "no-carriers-message" } }, [
                          _vm._v("No Carriers Available")
                        ])
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fbf1a89", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fbf1a89","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/admin/user/EditUser.vue
// module id = null
// module chunks = 